export default __webpack_public_path__ + "images/ad0d8518ea01b89129c5882bcf576957-government.png";